module.exports = __webpack_public_path__ + "img/check-motor-white.c331f3e4.svg";